module.exports = __webpack_public_path__ + "img/masculino.328b67f0.png";